import {
    converteFormatDateAPI,
    putZeroInFront,
    getFirstDayOfTheMonth,
    getLastDayOfTheMonth,
    getCurrentDayOfTheMonth
} from "./CustomFunction"

export const getPayloadData = (tab, filter, pagination) => {
    // tab = 1: Chart
    // tab = 2: Table
    // tab = 3: List
    let newDate = new Date();
    let currentYear = newDate.getFullYear();
    let currentMonth = newDate.getMonth() + 1;
    let currentDate = newDate.getDate()

    let obj = {
        token: localStorage.getItem("jwtTokenV2"),
        email: localStorage.getItem("email"),
        category: filter.category,
        behaviorIDs: filter.behaviorID,
        page: !pagination ? 1 : pagination.currentPage,
        limit: !pagination ? 10 : pagination.currentLimit
    }
    let copyObj = obj; // dublicate Obj
    let type = filter.duration; // get start and end date
    let monthly = 1; // type = 1: filter by month
    let yearly = 2; // type = 2: filter by year
    let range = 3; // type = 3: filter by range
    let daily = 4; // type = 4: filter by daily
    let today = 5;
    let categoryType = filter.item; // filter.item: filter by type of category
    let byItem = 1; // item = 1: filter by Item
    let byCategory = 2; // item = 2: filter by Category

    // selected date 
    let selectedYear = filter.year;
    let selectedMonth = filter.month;
    let selectedStartRange = filter.range.start.split("-");
    let selectedEndRange = filter.range.end.split("-");

    let selectedStartDaily = filter.daily.split("-");
    let date = new Date();

    if (type == monthly) {
        obj = {
            ...copyObj,
            startDate:
                converteFormatDateAPI(
                    selectedYear,
                    putZeroInFront(selectedMonth),
                    putZeroInFront(
                        getFirstDayOfTheMonth(
                            selectedYear,
                            selectedMonth
                        )
                    )),
            endDate:
                converteFormatDateAPI(
                    selectedYear,
                    putZeroInFront(selectedMonth),
                    currentMonth != selectedMonth ?
                        putZeroInFront(
                            getLastDayOfTheMonth(
                                selectedYear,
                                selectedMonth
                            )
                        ) :
                        putZeroInFront(getCurrentDayOfTheMonth())
                )
        }
    } else if (type == yearly) {
        obj = {
            ...copyObj,
            startDate: converteFormatDateAPI(
                selectedYear,
                putZeroInFront(1),
                putZeroInFront(1)
            ),
            endDate: converteFormatDateAPI(
                selectedYear,
                putZeroInFront(currentYear != selectedYear ? 12 : selectedMonth),
                currentYear != selectedYear ? getLastDayOfTheMonth(selectedYear, 12) : putZeroInFront(currentDate)
            ),
        }
    } else if (type == range) {
        obj = {
            ...copyObj,
            startDate: converteFormatDateAPI(
                selectedStartRange[0],
                selectedStartRange[1],
                selectedStartRange[2]
            ),
            endDate: converteFormatDateAPI(
                selectedEndRange[0],
                selectedEndRange[1],
                selectedEndRange[2]
            ),
        };
    } else if (type == daily || type == today) {
        obj = {
            ...copyObj,
            startDate: converteFormatDateAPI(
                selectedStartDaily[0],
                selectedStartDaily[1],
                selectedStartDaily[2]
            ),
            endDate: converteFormatDateAPI(
                selectedStartDaily[0],
                selectedStartDaily[1],
                selectedStartDaily[2]
                // date.getFullYear(),
                // selectedStartDaily[1],
                // putZeroInFront(getLastDayOfTheMonth(date.getFullYear(), selectedStartDaily[1]))
            )
        };
    } else {
        obj = {
            ...copyObj,
            startDate: converteFormatDateAPI(
                selectedYear,
                putZeroInFront(selectedMonth),
                putZeroInFront(1)
            ),
            endDate: converteFormatDateAPI(
                selectedYear,
                putZeroInFront(selectedMonth),
                putZeroInFront(currentDate)
            ),
        }
    }

    let result = {}

    if (categoryType == byItem) {
        if (tab == 1) {
            delete obj.page;
            delete obj.limit;

            result = {
                ...obj,
                year: 0,
                output: "",
                redis: 1,
            };
        } else if (tab == 2) {
            result = {
                ...obj,
                token: localStorage.getItem('jwtTokenV2'),
                // studentID: "",
                category: filter.category == "school" ? filter.category : "class",
                categoryID: filter.category == "school" ? "" : filter.behaviorID,
            };
        } else if (tab == 3) {
            result = {
                ...obj,
                duration: type == daily ? "daily" : "range",
                year: selectedYear,
            };
        } else {
            delete obj.page;
            delete obj.limit;

            result = {
                ...obj,
                year: obj.endDate.substring(0, 4)
            }
        }
    } else if (categoryType == byCategory) {
        result = {
            ...obj,
            token: localStorage.getItem('jwtTokenV2'),
            // studentID: filter.category == "school" ? "" : filter.category,
            category: filter.category == "school" ? "school" : "class",
            categoryID: filter.behaviorID,
        };
    } else {
        result = {
            ...obj,
            studentID: "",
            category: "school",
            categoryID: filter.behaviorID,
            startDate: data.startDate,
            endDate: data.endDate,
        };
    }
    return result
}


// WEBPACK FOOTER //
// ./src/components/OverallReporting/getData.js